import { GDTFConverter } from "@coten-inc/utils";

const CHUNK_SIZE = 100;
export const BUFFER_CHUNKS = 1;
export const DEFAULT_RANGE_YEARS = 500;
export const CACHE_TTL_MS = 24 * 60 * 60 * 1000;
export const MAX_FILTER_HASHES = 30;
export const MAX_CONCURRENT_FETCHES = 5;

/** Returns the chunk ID for a given year. Chunk 16 = years 1600–1699. */
const chunkIdForYear = (year: number): number => Math.floor(year / CHUNK_SIZE);

/**
 * Returns the [jdnGte, jdnLte] integer bounds for a chunk using Julian Day Numbers.
 * JDN integer comparison is reliable for all eras including BCE.
 */
export const chunkJDNBounds = (chunkId: number): [number, number] => {
  const startYear = chunkId * CHUNK_SIZE;
  const endYear = startYear + CHUNK_SIZE - 1;
  const startJDN = new GDTFConverter(String(startYear)).getJDN() ?? 0;
  const endJDN = new GDTFConverter(`${endYear}-12-31`).getJDN() ?? 0;
  return [startJDN, endJDN];
};

/** Returns all chunk IDs overlapping [rangeStart, rangeEnd] plus buffer on each side. */
export const chunkIdsForRange = (range: [number, number], buffer: number): number[] => {
  const startId = chunkIdForYear(range[0]) - buffer;
  const endId = chunkIdForYear(range[1]) + buffer;
  const ids: number[] = [];
  for (let id = startId; id <= endId; id++) ids.push(id);
  return ids;
};
